import {
  ClickElementTypes,
  ElementTypes,
  EventActions,
} from "@phn/utility/constants";
import { getCurrentRoute } from "../../services/routing-manager";
import analyticsManager from "../../services/analytics/analytics-manager";
import { GlobalDataLayerService } from "@phn/services/analytics/global-data-layer-service";
import type {
  ModelBanner,
  BodyType,
  TLink,
} from "@phn/entities/content";

export function sendMetaFunctionDataLayerEvent(link: TLink): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.MODEL_CTA_CLICK,
    {
      componentClick: {
        clickElementId: link.id,
        clickElementName: link.text,
        clickElementType: ClickElementTypes.Link,
        targetUrl: link.link,
      },
      componentDisplay: {
        displayElementId: analyticsManager.calculateDisplayElementId(),
        displayElementType: analyticsManager.calculateDisplayElementType(
          getCurrentRoute(),
          ElementTypes.bodyTypeButton,
        ),
        displayElementName: link.text,
      },
      car: {
        modelRangeName: link.id.split(".")[1],
      },
    },
  );
}

export function sendBodyTypeClickDataLayerEvent(
  bodyType: BodyType,
  tagName: string,
): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.MODEL_CLICK,
    {
      componentClick: {
        clickElementId: bodyType.id,
        clickElementName: bodyType.name,
        clickElementType:
          tagName === "IMG" ? ClickElementTypes.Image : ClickElementTypes.Link,
        targetUrl: bodyType.link,
      },
      componentDisplay: {
        displayElementId: analyticsManager.calculateDisplayElementId(),
        displayElementType: analyticsManager.calculateDisplayElementType(
          getCurrentRoute(),
          ElementTypes.bodyTypeButton,
        ),
        displayElementName: bodyType.name,
      },
      car: {
        modelCode: bodyType.modelType,
        modelRangeName: bodyType.id.split(".")[1],
        modelName: analyticsManager.getModelName(bodyType),
        engineType: analyticsManager.getEngineTypes(bodyType),
      },
    },
  );
}

export function sendModelBannerClickDataLayerEvent(
  model: ModelBanner,
  tagName: string,
): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.MODEL_CLICK,
    {
      componentClick: {
        clickElementId: model.id,
        clickElementName: model.name,
        clickElementType:
          tagName === "IMG" ? ClickElementTypes.Image : ClickElementTypes.Link,
        targetUrl: model.link,
      },
      componentDisplay: {
        displayElementId: analyticsManager.calculateDisplayElementId(),
        displayElementType: analyticsManager.calculateDisplayElementType(
          getCurrentRoute(),
          ElementTypes.bodyTypeButton,
        ),
        displayElementName: model.name,
      },
      car: {
        modelCode: model.modelType,
        modelRangeName: model.id.split(".")[1],
        modelName: model.name,
        engineType: model.tags,
      },
    },
  );
}

export function sendNavigationDataLayerEvent(series): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.MODEL_CLICK,
    {
      componentClick: {
        clickElementId: series.all.id,
        clickElementName: series.all.text,
        clickElementType: ClickElementTypes.Link,
        targetUrl: series.all.link,
      },
      componentDisplay: {
        displayElementId: analyticsManager.calculateDisplayElementId(),
        displayElementType: analyticsManager.calculateDisplayElementType(
          getCurrentRoute(),
          ElementTypes.bodyTypeButton,
        ),
        displayElementName: series.all.text,
      },
    },
  );
}
